import React from "react";

export function WarningsNotice({warnings}) {
    const items = warnings ?? [];
    if (!items.length) return null;
    return <div className="notice" role="status">{items.join(" ")}</div>;
}
